export const Types = {
    SAVE_LIST_NFC: 'SAVE_LIST_NFC',
}
